// @ts-check
import * as React from 'react'
import PropTypes from 'prop-types'

/**
 * @typedef {object} TabBase
 * @property {string} label
 * @property {boolean} active
 *
 * @typedef {object} TabLink
 * @property {string} href
 * @property {never} [onClick]
 *
 * @typedef {object} TabButton
 * @property {() => void} onClick
 * @property {never} [href]
 *
 * @typedef {TabBase & (TabLink | TabButton)} Tab
 *
 * @typedef {object} Props
 * @property {Array.<Tab>} tabs
 * @property {boolean} [unspaced]
 */

/** @param {Tab} tab */
const tabClassName = (tab) => {
  const matchesCurrentHref =
    typeof window !== 'undefined' && window.location.href === tab?.href

  return [
    'caption',
    'tabs__link',
    tab.active || matchesCurrentHref ? 'tabs__link--active' : ''
  ].join(' ')
}

/** @param {Props} props */
const Tabs = ({ tabs = [], unspaced = false }) => {
  if (tabs?.length === 0) return null
  return (
    <div className={`tabs ${unspaced && 'tabs--unspaced'}`}>
      <ul className="tabs__list">
        {tabs.map((tab) => (
          <li className="tabs__item" key={tab.label}>
            {tab.href && (
              <a className={tabClassName(tab)} href={tab.href}>
                {tab.label}
              </a>
            )}
            {tab.onClick && (
              <button
                type="button"
                className={tabClassName(tab)}
                onClick={tab.onClick}
              >
                {tab.label}
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

Tabs.propTypes = {
  tabs: PropTypes.shape({
    label: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func
  }).isRequired
}
export default Tabs
